<div class="subscription-savings-promo" *transloco="let t">
  @if (savingsPlan()){
    <span>
      {{isMultiplePlans()
        ? t('shared_components.sub_cart_promo.subscription_savings_multi', {savings: savingsPlan()})
        : t('shared_components.sub_cart_promo.subscription_savings_single', {savings: savingsPlan(), planName: planName()})}}
    </span>
  } @else {
    <span>
      {{ t('shared_components.sub_cart_promo.subscription_savings_general') }}
    </span>
  }
  <br />
  <a class="subscription-savings-link" [href]="premiumRoute">
    {{isMultiplePlans()
      ? t('shared_components.sub_cart_promo.subscription_savings_check_plans')
      : t('shared_components.sub_cart_promo.subscription_savings_check_plan')}}
  </a>
</div>